import { Formik, Form } from "formik";
import { useCallback, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal, Alert } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import TextBox from "../../../controls/form/TextBox";
import Forms from "../../../../services/forms";
import * as Yup from "yup";
import DataListOptionControl from "../DataListOptionControl";

const EditDataList = ({
    show,
    onAdd,
    onUpdate,
    onClose,
    dataList
}) => {
    const { id: deploymentId } = useParams();
    const [translate] = useTranslation();

    const isEdit = dataList ? true : false;
    const [showSaveButton, setShowSaveButton] = useState(false);

    const handleOnChange = useCallback(() => {
        setShowSaveButton(true);
    }, []);

    const handleUpdate = useCallback(async (values) => {

        values.options.forEach(option => {
            if (option._touched_displayValue) {
                delete (option._touched_displayValue);
            }
            if (option._touched_value) {
                delete (option._touched_value);
            }
        });

        if (isEdit) {
            await Forms.updateDataList({
                deploymentId,
                dataListId: dataList._id,
                body: { ...values }
            });

            onUpdate();
        }
        else {
            await Forms.addDataList({
                deploymentId,
                body: { ...values }
            });

            onAdd();
        }
    }, [dataList, deploymentId, onAdd, onUpdate, isEdit]);

    const renderForm = useMemo(() => {
        return <Formik initialValues={{
            name: dataList?.name || "",
            options: dataList?.options || [],
        }} onSubmit={handleUpdate}
            validateOnMount
            validationSchema={Yup.object({
                name: Yup.string().required(translate("OTM_NAME_REQUIRED")),
                options: Yup.array().of(
                    Yup.object({
                        displayValue: Yup.string().required(translate("OTM_DISPLAY_VALUE_REQUIRED")),
                        value: Yup.string().required(translate("OTM_DATA_VALUE_REQUIRED")),
                        variant: Yup.string().nullable()
                    })
                )
            })}
            enableReinitialize>
            {props => (<Form onChange={handleOnChange} className="flex-grow-1 d-flex flex-column overflow-hidden">
                <Modal.Header>
                    <label className="h5">{translate('OTM_ADD_DATA_LIST')}</label>
                </Modal.Header>

                <Modal.Body>
                    <div className="row mt-n3 align-items-end">
                        <div className="col-12 mt-3">
                            <TextBox label={translate('OTM_NAME')} type="text" name="name" isRequired={true} />
                        </div>
                        {isEdit && <div className="col-12 mt-3">
                            <Alert variant="warning" className="m-0">
                                <span className="fw-bold">{translate("OTM_EDITING_DATA_LIST_WARNING")}</span>
                            </Alert>
                        </div>}
                        <DataListOptionControl
                            name="options"
                            onChange={handleOnChange}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {showSaveButton && props.isValid && <Button size='sm' variant='primary' type='submit'>{translate('OTM_SAVE')} </Button>}
                    <Button size='sm' variant='secondary' onClick={onClose}>{translate('OTM_CANCEL')} </Button>
                </Modal.Footer>
            </Form>)}
        </Formik >
    }, [onClose, handleUpdate, translate, dataList, isEdit, handleOnChange, showSaveButton])

    return <Modal
        size={'xl'}
        show={show}
        backdrop={'static'}
        scrollable={true}>
        {renderForm}
    </Modal>
}

export default EditDataList;